import { useEffect, useRef } from "react";
import WaterSystemSummaryTable from './WaterSystemSummaryTable';
import { useWaterSystemSearchModal } from "../reuseableComponents/WaterSystemSearchModalContext";

const WaterSystemDetailedInfoPage = () => {
  const { selectedWaterSystem: contextWaterSystem, showSystemSelectModal, setShowSystemSelectModal, isRestoringFromCookie } = useWaterSystemSearchModal();
  const selectedWaterSystem = contextWaterSystem || JSON.parse(sessionStorage.getItem("selectedWaterSystem") || "{}");
  const modalOpenedRef = useRef(false);

  useEffect(() => {
    // If selectedWaterSystem is not populated and modal is not already open, open the modal
    if ((!selectedWaterSystem || Object.keys(selectedWaterSystem).length === 0) && !showSystemSelectModal && !modalOpenedRef.current && !isRestoringFromCookie) {
      setShowSystemSelectModal(true);
      modalOpenedRef.current = true;
    }
  }, [selectedWaterSystem, showSystemSelectModal, setShowSystemSelectModal, isRestoringFromCookie]);

  return (
    <div className="water-system-summary">
      <h4>Detailed Info</h4>
      <br />
      {selectedWaterSystem && Object.keys(selectedWaterSystem).length > 0 && (
        <WaterSystemSummaryTable selectedWaterSystem={selectedWaterSystem} />
      )}
    </div>
  );
}
export default WaterSystemDetailedInfoPage;